import * as React from 'react'

import { styled } from '../../../common/ui'
import { theme } from '../theme'

export class A extends React.Component<
  { icon?: React.ReactNode } & React.AnchorHTMLAttributes<HTMLAnchorElement>,
  {}
> {
  render() {
    const { children, icon, ...rest } = this.props
    return (
      <C {...rest}>
        <Inner>
          {icon && <Icon>{icon}</Icon>}
          <Children>{children}</Children>
        </Inner>
      </C>
    )
  }
}

const Inner = styled.span`
  display: flex;

  align-items: center;
  align-content: center;
  justify-content: center;
  justify-items: center;
`
const Children = styled.span`
  display: block;

  padding: 9px 0;
  text-align: center;
  color: #fff;
`
const Icon = styled.span`
  display: block;

  padding: 0;
  text-align: center;
  color: #fff;
  margin-right: 20px;
`

const C = styled.a`
  padding: 0 15px;
  text-align: center;
  border: 1px solid #fff;
  background: transparent;
  display: inline-block;
  color: #fff;
  font-size: 16px;
  text-transform: uppercase;

  text-decoration: none;
  &:hover {
    background: #fff;
    color: #000;
    text-decoration: none;
    cursor: pointer;
    svg {
      path {
        fill: #000;
      }
    }
    ${Children} {
      color: #000;
    }
    &:focus,
    &:active {
      outline: ${theme.outline};
    }
  }
`
